import { useQuery } from '@tanstack/react-query'

import { api } from '../api'
import TaskDialog from './TaskDialog'

/**
 * Открыть задачу, зная только её номер.
 *
 * Карточка задачи устроена вокруг готовой задачи: она заполняет поля формы
 * сразу, ещё до первой отрисовки. Поэтому там, где на руках один номер — в
 * карточке заявки, в сводке, в переписке, — задачу сначала подтягивают здесь,
 * а карточку показывают уже с данными.
 */
export default function TaskById({ id, onClose }: { id: number; onClose: () => void }) {
  const task = useQuery({ queryKey: ['task', id], queryFn: () => api.task(id) })

  if (task.isError) {
    return (
      <div className="overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
        <div className="modal" style={{ maxWidth: 420 }}>
          <h2>Задача № {id}</h2>
          <div className="modal-body">
            <div className="error">
              {(task.error as any)?.message ?? 'Не удалось открыть задачу'}
            </div>
          </div>
          <div className="modal-actions">
            <button className="btn" onClick={onClose}>
              Закрыть
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (!task.data) {
    return (
      <div className="overlay">
        <div className="modal" style={{ maxWidth: 420 }}>
          <div className="modal-body">
            <p className="empty">Открываем задачу № {id}…</p>
          </div>
        </div>
      </div>
    )
  }

  return <TaskDialog task={task.data} onClose={onClose} />
}
